var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.143 0C4.68834 0 4.2523 0.180612 3.93081 0.502103C3.60932 0.823594 3.42871 1.25963 3.42871 1.71429V8.57143C3.42871 9.02609 3.60932 9.46212 3.93081 9.78361C4.2523 10.1051 4.68834 10.2857 5.143 10.2857H10.2859C10.7405 10.2857 11.1765 10.1051 11.498 9.78361C11.8195 9.46212 12.0001 9.02609 12.0001 8.57143V3.78343C12 3.32881 11.8194 2.89284 11.4979 2.57143L9.42871 0.502286C9.10729 0.180772 8.67133 9.70927e-05 8.21671 0H5.143Z",
    fill: "#3D4852"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.14287C0 4.68822 0.180612 4.25218 0.502103 3.93069C0.823593 3.6092 1.25963 3.42859 1.71429 3.42859V12H8.57143C8.57143 12.4547 8.39082 12.8907 8.06933 13.2122C7.74783 13.5337 7.3118 13.7143 6.85714 13.7143H1.71429C1.25963 13.7143 0.823593 13.5337 0.502103 13.2122C0.180612 12.8907 0 12.4547 0 12V5.14287Z",
    fill: "#3D4852"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ad29bd772be19707bdbbba9a2ae207e2.svg";
export { ForwardRef as ReactComponent };